import { useTranslation } from 'react-i18next'
import React from 'react'

import UsersControlBar from './UsersControlBar'
import UsersCounterBar from './UsersCounterBar'

const PageHeader = () => {
  const { t } = useTranslation(['common', 'listUsers'])

  return (
    <>
      <UsersControlBar />
      <UsersCounterBar />
    </>
  )
}

export default PageHeader
